import React, { useEffect, useState } from 'react';
import { Button, Input, Select, Radio, Typography, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getProject,
  getIssues,
  searchJiraProjects,
  getServiceDeskProject,
} from '../../../../skills/skills_action';
import ApphomeFilterConditions from '../ApphomeFilter';
import qs from 'query-string';
import { addButtonAction, updateButtonAction } from '../ApphomeActions';
import axios from 'axios';
import JiraIssueFields from '../../../jira/jiraIssueFields';
const { Option } = Select;
const { Text } = Typography;
const AppHomeCreateAndUpdateButton = (props) => {
  const { view, id } = qs.parse(props.location.search);
  const isDarkTheme = localStorage.getItem('theme') == 'dark' ? true : false;

  const isPersonalApphome = props.isPersonalApphome ? true : false;
  const apphome = useSelector((state) => state.apphome.apphome);
  const pageInfo =
    apphome &&
    apphome.pages &&
    apphome.pages.find((page) => page._id === (apphome && apphome.pageView));
  const pageViewType = pageInfo && pageInfo.pageViewType;
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [purpose, setPurpose] = useState('');
  const [buttonType, setButtonType] = useState('create');
  const [project, setProject] = useState({});
  const [issueType, setIssueType] = useState({});
  const [issueTypeLoading, setIssueTypeLoading] = useState(false);
  const [findType, setFindType] = useState('prebuiltfilter');
  const [preBuiltFilter, setPreBuiltFilter] = useState(
    pageViewType === 'issues' ? 'assigned_to_me' : 'tickets_by_status'
  );
  const [customFilters, setCustomFilters] = useState([]);
  const [jqlFilter, setJqlFilter] = useState('');
  const [showJqlError, setShowJqlError] = useState(false);
  const [selectedFilterFromJira, setSelectedFilterFromJira] = useState('');
  const [errors, setErrors] = useState({});
  const skills = useSelector((state) => state.skills.skills);
  const projects = useSelector((state) => state.skills.projects);
  const jsdProjects = useSelector((state) => state.skills.jsd_projects);
  const wId = props.match.params.wId;
  const requestTypes = useSelector((state) => state.skills.requestTypes);
  const issueTypes = useSelector((state) => state.skills.issues);
  const jiraSkill = skills && skills.find((el) => el.key === 'jira');
  const [fieldDefaults, setFieldDefaults] = useState({});
  const [showDefaultsModalVisible, setShowDefaultsModalVisible] =
    useState(false);
  const [selectedActionForUpadate, set_selectedActionForUpadate] =
    useState(null);
  useEffect(() => {
    if (view === 'updateAction') {
      const findPage =
        apphome &&
        apphome.pages &&
        apphome.pages.find((page) => page._id === apphome.pageView);
      const findButtonAction =
        findPage &&
        findPage.actions &&
        findPage.actions.find((el) => el._id === id);

      if (findButtonAction) {
        setName(findButtonAction.name);
        setPurpose(findButtonAction.purpose);
        setButtonType(findButtonAction.buttonType);
        setProject(
          findButtonAction &&
            findButtonAction.metadata &&
            findButtonAction.metadata.project
            ? findButtonAction.metadata.project
            : {}
        );
        if (
          findButtonAction &&
          findButtonAction.metadata &&
          findButtonAction.metadata.project
        ) {
          getIssueTypesList(findButtonAction);
        }
        setIssueType(
          findButtonAction &&
            findButtonAction.metadata &&
            findButtonAction.metadata.issueType
            ? findButtonAction.metadata.issueType
            : {}
        );
        setFieldDefaults(
          findButtonAction &&
            findButtonAction.metadata &&
            findButtonAction.metadata.fieldDefaults
            ? findButtonAction.metadata.fieldDefaults
            : {}
        );
        if (
          findButtonAction.metadata &&
          findButtonAction.metadata.preBuiltFilter
        ) {
          setPreBuiltFilter(findButtonAction.metadata.preBuiltFilter);
        }
        if (findButtonAction.metadata && findButtonAction.metadata.jqlFilter) {
          setJqlFilter(findButtonAction.metadata.jqlFilter);
        }
        if (
          findButtonAction.metadata &&
          findButtonAction.metadata.customFilters
        ) {
          setCustomFilters(findButtonAction.metadata.customFilters);
        }
        if (
          findButtonAction.metadata &&
          findButtonAction.metadata.selectedFilterFromJira
        ) {
          setSelectedFilterFromJira(
            findButtonAction.metadata.selectedFilterFromJira
          );
        }
        if (findButtonAction.metadata && findButtonAction.metadata.findType) {
          setFindType(findButtonAction.metadata.findType);
        }
      }
    }
  }, [view]);

  const getIssueTypesList = async (findButtonAction) => {
    try {
      await dispatch(
        getIssues(
          props.match.params.wId,
          findButtonAction.metadata.project.id,
          pageViewType === 'issues' ? false : true,
          pageViewType === 'issues' ? false : true
        )
      ).then((res) => {
        if (res.data.success && res.data.issueTypes) setIssueTypeLoading(false);
        // if (res.data.success && res.data.issueTypes && res.data.issueTypes[0]) this.setState({ defaultIssueType: res.data.issueTypes[0] });
      });
    } catch (error) {}
  };

  const getRequiredData = () => {
    const serverType =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.metadata &&
      jiraSkill.skill_metadata.metadata.server_type;

    if (pageViewType === 'requests') {
      dispatch(
        getServiceDeskProject(
          wId,
          jiraSkill && jiraSkill.skill_metadata && jiraSkill.skill_metadata._id,
          {
            saveInJSDProjects: true,
          }
        )
      );
    } else {
      if (serverType === 'jira_server_oauth' || serverType === 'jira_server') {
        dispatch(getProject(wId));
      } else {
        dispatch(searchJiraProjects(wId, ''));
      }
    }
  };

  const getProjectOptions = () => {
    if (pageViewType === 'requests') {
      return (
        jsdProjects &&
        jsdProjects.map((project, index) => (
          <Option key={project.id} value={project.projectId} project={project}>
            {project.projectName + ` (${project.projectKey})`}
          </Option>
        ))
      );
    } else if (pageViewType === 'issues') {
      const filterProjectsBasedonPageView =
        projects && pageViewType === 'issues'
          ? projects.filter((item) => item.projectTypeKey !== 'service_desk')
          : projects.filter((item) => item.projectTypeKey === 'service_desk');
      return (
        filterProjectsBasedonPageView &&
        filterProjectsBasedonPageView.map((project, index) => (
          <Option key={project.id} value={project.id} project={project}>
            {project.name + ` (${project.key})`}
          </Option>
        ))
      );
    }
  };

  const onChangeProject = async (value, event) => {
    setIssueType({});
    setIssueTypeLoading(true);
    if (event && event.project) {
      setProject(event.project);
      await dispatch(
        getIssues(
          props.match.params.wId,
          event.key,
          pageViewType === 'issues' ? false : true,
          pageViewType === 'issues' ? false : true
        )
      ).then((res) => {
        if (res.data.success && res.data.issueTypes) setIssueTypeLoading(false);
        // if (res.data.success && res.data.issueTypes && res.data.issueTypes[0]) this.setState({ defaultIssueType: res.data.issueTypes[0] });
      });
    }
  };
  const onChangeIssueType = (value, event) => {
    setIssueType(event && event.issueType ? event.issueType : {});
  };

  useEffect(() => {
    getRequiredData();
  }, []);

  const validateButtons = async (type) => {
    try {
      const errorsObj = {};
      if (!name) errorsObj.name = 'Name is required';
      if (name) {
        if (type === 'create') {
          const isButtonNameAlreadyExist = props.buttonsList.find(
            (button) => button.name === name
          );

          if (isButtonNameAlreadyExist) {
            errorsObj.name = `Name in use. Choose unique name.`;
          }
        } else {
          const isButtonNameAlreadyExist = props.buttonsList.find(
            (button) => button.name === name
          );
          if (isButtonNameAlreadyExist && isButtonNameAlreadyExist._id !== id) {
            errorsObj.name = `Name in use. Choose unique name.`;
          }
        }
      }
      if (!purpose) errorsObj.purpose = 'Purpose is required';
      if (buttonType === 'create') {
        // if (!(project.name || project.projectName)) {
        //   errorsObj.project = 'Project is required';
        // }
        if ((project.name || project.projectName) && !issueType.value) {
          errorsObj.issuetype = `${
            pageViewType === 'issues' ? 'Issue' : 'Request'
          } Type is required`;
        }
      }
      if (buttonType === 'find') {
        if (findType === 'customfilter') {
        } else if (findType === 'jqlfilter') {
          if (!jqlFilter) {
            errorsObj.jqlFilter = 'Jql is required';
          } else {
            const response = await axios.post(
              `/bot/api/w/${props.match.params.wId}/jira/verifyJql`,
              { jql: jqlFilter }
            );
            if (response.data.success == false) {
              errorsObj.jqlFilter =
                response.data.error && response.data.error.message
                  ? response.data.error.message
                  : 'Invalid JQL';
            }
          }
        } else if (findType === 'filterfromjira') {
          if (!selectedFilterFromJira) {
            errorsObj.selectedFilterFromJira = '* Pleas select a filter';
          }
        }
      }
      setErrors(errorsObj);
      return Object.keys(errorsObj).length > 0 ? false : true;
    } catch (error) {
      // console.log(error);
    }

    // return Object.keys(errorsObj).length > 0;
  };
  const createButton = async () => {
    const isValid = await validateButtons('create');
    if (isValid) {
      const data = {
        name,
        purpose,
        buttonType,
        metadata: {
          project,
          issueType,
          findType,
          jqlFilter,
          preBuiltFilter,
          selectedFilterFromJira,
          fieldDefaults,
          customFilters,
        },
      };
      await dispatch(
        addButtonAction(wId, apphome && apphome._id, apphome.pageView, data)
      );
      if (isPersonalApphome) {
        props.history.push(
          `/${props.match.params.wId}/settings/personalapphome/customize?pageViewType=${pageViewType}&view=buttonList`
        );
      } else {
        props.history.push(
          `/${props.match.params.wId}/slackApp/apphome?pageViewType=${pageViewType}&view=buttonList`
        );
      }
    }
  };

  const updateButton = async () => {
    const isValid = await validateButtons();
    if (isValid) {
      const data = {
        name,
        purpose,
        buttonType,
        metadata: {
          project,
          issueType,
          findType,
          jqlFilter,
          preBuiltFilter,
          selectedFilterFromJira,
          fieldDefaults,
          customFilters,
        },
      };
      await dispatch(
        updateButtonAction(
          wId,
          apphome && apphome._id,
          apphome.pageView,
          id,
          data
        )
      );
      if (isPersonalApphome) {
        props.history.push(
          `/${props.match.params.wId}/settings/personalapphome/customize?pageViewType=${pageViewType}&view=buttonList`
        );
      } else {
        props.history.push(
          `/${props.match.params.wId}/slackApp/apphome?pageViewType=${pageViewType}&view=buttonList`
        );
      }
    }
  };

  return (
    <div
      className='apphome_create_button_container'
      style={{ background: `${isDarkTheme ? '' : '#fff'}` }}
    >
      <Modal
        title='Set Field values'
        visible={showDefaultsModalVisible}
        onOk={() => setShowDefaultsModalVisible(false)}
        okText='Update'
        onCancel={() => setShowDefaultsModalVisible(false)}
        maskClosable={false}
        destroyOnClose={true}
        centered
        bodyStyle={{
          maxHeight: '70vh',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {jiraSkill && (
          <>
            <JiraIssueFields
              issues={issueTypes}
              linkedIssue={issueType.value}
              linkedProject={project.id ? project.id : null}
              handleFieldDefaultsChange={(fieldDefaults) => {
                setFieldDefaults({
                  ...fieldDefaults[issueType.value],
                });
              }}
              selectedCommandForUpdate={{
                issueType: { value: issueType.value },
                fieldDefaults,
              }}
              skill_id={jiraSkill && jiraSkill.skill_metadata._id}
              forCommands={true}
            />
          </>
        )}
      </Modal>
      <div className='apphome_create_button_container_child'>
        <div className='apphome_create_button_container_child_title'>
          Button Name
        </div>
        <div>
          {errors.name && <div style={{ color: 'red' }}>* {errors.name}</div>}
          <Input
            value={name}
            onChange={(event) => setName(event.target.value)}
            style={{ width: '500px' }}
            placeholder=''
          />
        </div>
      </div>
      <div className='apphome_create_button_container_child'>
        <div className='apphome_create_button_container_child_title'>
          Purpose
        </div>
        <div>
          {errors.purpose && (
            <div style={{ color: 'red' }}>* {errors.purpose}</div>
          )}
          <Input
            value={purpose}
            onChange={(event) => setPurpose(event.target.value)}
            style={{ width: '500px' }}
            placeholder='quickly create an issue in current sprint'
          />
        </div>
      </div>
      <div className='apphome_create_button_container_child'>
        <div className='apphome_create_button_container_child_title'>
          Button Type
        </div>
        <div>
          <Select
            value={buttonType}
            onChange={(value) => setButtonType(value)}
            style={{ width: '250px' }}
          >
            <Option value='create'>
              {pageViewType === 'issues' ? 'Issue Create' : 'Request Create'}
            </Option>
            {pageViewType === 'issues' && (
              <Option value='find'>Issue Find</Option>
            )}
            <Option value='channelsync'>Channel sync</Option>
          </Select>
        </div>
      </div>
      <div style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.06)' }}></div>
      {buttonType === 'create' && (
        <div className='apphome_create_button_container_child'>
          <div
            style={{ marginTop: '22px' }}
            className='apphome_create_button_container_child_title'
          >
            Creation Defaults
          </div>
          <div>
            {errors.project ? (
              <div style={{ color: 'red' }}>* {errors.project}</div>
            ) : (
              <div>&nbsp;</div>
            )}
            <Select
              allowClear
              style={{ width: '250px' }}
              name='project'
              value={project.projectId || project.id}
              onChange={onChangeProject}
              showSearch={true}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              placeholder='Select Project'
              onClear={() => {
                setIssueType({});
                setProject({});
              }}
            >
              {getProjectOptions()}
            </Select>
          </div>
          <div>
            {errors.issuetype ? (
              <div style={{ color: 'red' }}>* {errors.issuetype}</div>
            ) : (
              <div>&nbsp;</div>
            )}
            <Select
              allowClear
              style={{ width: 250, marginRight: 8 }}
              name='defaultIssue'
              value={issueType.value}
              onChange={onChangeIssueType}
              showSearch={true}
              loading={issueTypeLoading}
              placeholder={`Select ${
                pageViewType === 'issues' ? 'Issue type' : 'Request type'
              }`}
            >
              {apphome &&
                pageViewType === 'issues' &&
                issueTypes.map((issueType, index) => (
                  <Option
                    key={issueType.value}
                    value={issueType.value}
                    issueType={issueType}
                  >
                    {issueType.text}
                  </Option>
                ))}
              {apphome &&
                pageViewType === 'requests' &&
                requestTypes.map((issueType, index) => (
                  <Option
                    key={issueType.value}
                    value={issueType.value}
                    issueType={issueType}
                  >
                    {issueType.text}
                  </Option>
                ))}
            </Select>
          </div>
          <div>
            <div>&nbsp;</div>
            {(project.projectId || project.id) &&
              pageViewType === 'issues' &&
              issueType.value && (
                <div>
                  <Text style={{ marginRight: 4 }}>
                    {Object.keys(fieldDefaults).length > 0
                      ? `${
                          Object.keys(fieldDefaults).length
                        } field value(s) set`
                      : 'No field values set'}
                  </Text>
                  <a onClick={() => setShowDefaultsModalVisible(true)}>
                    Update
                  </a>
                  <Text> | </Text>
                  <a
                    onClick={() => {
                      setFieldDefaults({});
                    }}
                  >
                    Clear
                  </a>
                </div>
              )}
          </div>
        </div>
      )}
      {buttonType === 'find' && (
        <div className='apphome_create_button_container_child'>
          <div className='apphome_create_button_container_child_title'>
            Filter Condtion
          </div>
          <div>
            <div>
              <ApphomeFilterConditions
                findType={findType}
                setFindType={setFindType}
                apphome={apphome}
                preBuiltFilter={preBuiltFilter}
                setPreBuiltFilter={setPreBuiltFilter}
                customFilters={customFilters}
                setJqlFilter={setJqlFilter}
                jqlFilter={jqlFilter}
                setCustomFilters={setCustomFilters}
                selectedFilterFromJira={selectedFilterFromJira}
                setSelectedFilterFromJira={setSelectedFilterFromJira}
                errors={errors}
              />
            </div>
            <div></div>
          </div>
        </div>
      )}

      <div>
        {props.view === 'createAction' && (
          <Button onClick={createButton} type='primary'>
            Create
          </Button>
        )}
        {props.view === 'updateAction' && (
          <Button onClick={updateButton} type='primary'>
            Update
          </Button>
        )}
      </div>
    </div>
  );
};

export default withRouter(AppHomeCreateAndUpdateButton);
